import {DataTableColumn} from "mantine-datatable";
import {I18n} from "@aws-amplify/core";
import {Text} from "@mantine/core";
import {Link} from "react-router-dom";
import {Order} from "../types.ts";

export const useTableColumns = (
    {onRecordClick}: { onRecordClick: (record: Order) => void },
) => {

    const columns: DataTableColumn<Order>[] = [
        {
            accessor: 'id',
            title: I18n.get('Order ID'),
            render: (record: Order) => (
                <Text
                    c="blue"
                    style={{cursor: 'pointer'}}
                    onClick={() => onRecordClick(record)}
                >
                    {record.id}
                </Text>
            ),
        },
        {
            accessor: 'subscriptionId',
            title: I18n.get('Subscription ID'),
            render: (record: Order) => (
                <Link
                    to={`/customers/${record.customerId}/subscriptions/${record.subscriptionId}`}
                    style={{textDecoration: 'none'}}
                >
                    <Text c="blue" style={{cursor: 'pointer'}}>
                        {record.subscriptionId}
                    </Text>
                </Link>
            ),
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            render: (record: Order) => (
                <Text size="sm">
                    {record.created ? new Date(record.created).toLocaleDateString() : '-'}
                </Text>
            ),
        },
    ];

    return {
        columns,
    };
};
